import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import ClientManagement from "./components/ClientManagement";
import Login from "./components/Login";
import AdminSetup from "./components/AdminSetup";
import MigrationTool from "./components/MigrationTool";
import { AuthProvider } from "./context/AuthContext";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/setup" element={<AdminSetup />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/clients" element={<ClientManagement />} />
            <Route path="/migrate" element={<MigrationTool />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
